module.exports = __webpack_public_path__ + "img/horizontal_3_3_r_pp3_9006.bfcf4b75.png";